import axios from 'axios';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import {APIUrl} from '../constants/ApplicationConstants';
import {Constants} from '../constants/WorkItemConstants';
import ErrorHandler from '../core/ErrorHandler.js';

module.exports = {
    sendWorkFile: function(productId, applicationId, responseList, workFile, yourDetails) {
        const backfileUrl = APIUrl.BACKFILE_WORKFILE_URL.replace('{aid}', applicationId).replace('{pid}', productId);
        const filenoteUrl = APIUrl.FILENOTE_WORKFILE_URL.replace('{aid}', applicationId).replace('{pid}', productId);

        var oinList = [];

        _.forEach(responseList, function(item) {
            _.forEach(item.oinList, function(oin) {
                if (oinList.indexOf(oin) === -1) {
                    oinList.push(oin);
                }
            });
        });

        
        if (workFile.backFile && workFile.backFile.data) {
            let data = '';

            _.forEach(responseList,
                function(item) {
                    data += Constants.BackFileDataSeparator +
                        workFile.backFile.data
                        .replace(new RegExp(Constants.BackfileCustomerAccountNumber, 'g'), item.accountNumber)
                        .replace(new RegExp(Constants.BackfileCustomerTrn, 'g'), item.trn)
                        .replace(new RegExp(Constants.BackfileCustomerOin, 'g'), oinList.join(', '))
                        .replace(new RegExp(Constants.BackfileCustomerAccountOpeningTime, 'g'), item.accountOpeningDate);
                });

            const backFile = {
                errors: workFile.backFile.errors,
                data: data,
                productId: productId,
                trn: responseList[0].trn,
                accountNumber: responseList[0].accountNumber,
                yourDetails: yourDetails
            };

            axios.post(backfileUrl, backFile)
                .then(ThrowIfStatusNotOk)
                .then((response) => {
                    console.log('Work Item: back file saved, has affected rows on DB: ' + response.data);
                })
                .catch((error) => {
                    // do not throw here
                    ErrorHandler.logError(Error('Work item backfile', error));
                });
        }

        if (workFile.fileNote && workFile.fileNote.data) {
            const data = workFile.fileNote.data.replace(new RegExp(Constants.FilenoteOin, 'g'), oinList.join('<br/>'));

            const fileNote = {
                errors: workFile.fileNote.errors,
                data: data,
                productId: productId,
                trn: responseList[0].trn,
                accountNumber: responseList[0].accountNumber,
                yourDetails: yourDetails
            };

            axios.post(filenoteUrl, fileNote)
                .then(ThrowIfStatusNotOk)
                .then((response) => {
                    console.log('Work Item: file note sent, has affected rows on DB: ' + response.data);
                })
                .catch((error) => {
                    // do not throw here
                    ErrorHandler.logError(Error('Work item filenote', error));
                });
        }
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/WorkItemAPI.js